// hooks/useEmployeeCalendarData.ts
import { useMemo } from "react";
import { useApiQuery } from "../../../../../infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../infrastructure/routes/endpointsMetadata";
import { IEmployeeWithAvailabilityModel } from "../models/employeeCalendarModels";

interface IUseEmployeeCalendarDataProps {
  selectedStudioId: number;
  enabled?: boolean;
}

export const useEmployeeCalendarData = ({
  selectedStudioId,
  enabled = true,
}: IUseEmployeeCalendarDataProps) => {
  const { startDate, endDate } = useMemo(() => {
    const today = new Date();
    const currentMonthStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    const futureDate = new Date(today);
    futureDate.setFullYear(today.getFullYear() + 2);

    return {
      startDate: currentMonthStart.toISOString().split("T")[0], // Format as YYYY-MM-DD
      endDate: futureDate.toISOString().split("T")[0],
    };
  }, []);

  const queryKey = [
    endpointsMetadata.studio.getStudioInstructors,
    selectedStudioId,
    startDate,
    endDate,
  ];

  // forEventWizard signals the backend to restrict the instructor list to the
  // current employee when they may only manage their own events. The refill /
  // direct-sale card calls the same endpoint without this flag and keeps the full list.
  const endpoint = `${endpointsMetadata.studio.getStudioInstructors}?userPlanId=0&startDate=${startDate}&endDate=${endDate}&forEventWizard=true`;

  const { data: studioEmployees, ...queryResult } = useApiQuery<
    IEmployeeWithAvailabilityModel[]
  >({
    queryKey,
    endpoint,
    enabled: enabled && selectedStudioId > 0,
    globalIsLoading: false,
  });

  return {
    studioEmployees,
    ...queryResult,
  };
};
